"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTabMenu = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var AcTabMenuItem_1 = require("./AcTabMenuItem");
var AcTabMenu = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'underline' : _b, items = _a.items, className = _a.className, activeItemId = _a.activeItemId, center = _a.center, onClick = _a.onClick, onClickEdit = _a.onClickEdit;
    var onClickItem = function (id) {
        onClick === null || onClick === void 0 ? void 0 : onClick(id);
    };
    var onClickEditItem = function (id, title) {
        onClickEdit === null || onClickEdit === void 0 ? void 0 : onClickEdit(id, title);
    };
    return (react_1.default.createElement("div", { className: clsx_1.default('tab-menu-container', type, className) },
        react_1.default.createElement("div", { className: "d-flex flex-row " + (center ? 'justify-content-center' : '') }, Array.isArray(items) &&
            items.map(function (item) {
                return (react_1.default.createElement(AcTabMenuItem_1.AcTabMenuItem, { type: type, key: item.id, id: item.id, title: item.title, icon: item.icon, iconStyle: item.iconStyle, textClassName: item.textClassName, expandableMenu: item.expandableMenu, active: item.active ? item.active : activeItemId === item.id, path: item.path, actionIcon: item.actionIcon, onClick: item.onClick || onClickItem, onClickEdit: item.onClickEdit || onClickEditItem }));
            }))));
};
exports.AcTabMenu = AcTabMenu;
exports.AcTabMenu.displayName = 'AcTabMenu';
//# sourceMappingURL=AcTabMenu.js.map